<template>
    <v-container>
        <v-layout row v-if="error">
            <v-flex xs12 sm8 offset-sm2>
                <app-alert @dismissed="onDismissed" :text="error.message"></app-alert>
            </v-flex>
        </v-layout>
        <v-layout>
            <v-flex xs12 sm8 offset-sm2>
                <v-card>
                    <v-card-text>
                        <v-container>
                            <v-form @submit.prevent="onSignin">
                                <v-layout row lazy-validation>
                                    <v-flex xs12>
                                        <v-text-field name="email" label="Mail" id="email" v-model="email" type="email" :rules="[rules.email]" required></v-text-field>
                                    </v-flex>
                                </v-layout>
                                <v-layout row>
                                    <v-flex xs12>
                                        <v-text-field name="password" label="Mot de passe" id="password" v-model="password" type="password" :rules="[rules.required, rules.password]" required></v-text-field>
                                    </v-flex>
                                </v-layout>
                                <v-layout row>
                                    <v-flex xs12>
                                        <v-btn
                                            type="submit"
                                            :loading="loading"
                                            :disabled="!formIsValid"
                                            class="light-blue lighten-4 blue-grey--text text--darken-3"
                                            >
                                            Sign up
                                            <span slot="loader" class="custom-loader">
                                                <v-icon light>cached</v-icon>
                                            </span>
                                        </v-btn>
                                    </v-flex>
                                </v-layout>
                            </v-form>
                        </v-container>
                    </v-card-text>
                </v-card>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
export default {
    data() {
        return {
            email: '',
            password: '',
            rules: {
                required: value => !!value || 'Champ requis.',
                password: value => value.length >= 6 || '6 caractères minimum',
                email: value => {
                    const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                    return pattern.test(value) || 'Mail invalide.'
                },
            }
        }
    },
    computed: {
        user() {
            return this.$store.getters.user
        },
        error() {
            return this.$store.getters.error
        },
        loading() {
            return this.$store.getters.loading
        },
        formIsValid() {
            return this.email !== '' &&
            this.password !== ''
        }
    },
    watch: {
        user(value) {
            if (value !==null && value !== undefined) {
                this.$router.push('/listes')
            }
        }
    },
    methods: {
        onSignin() {
            // Vuex
            this.$store.dispatch('signUserIn', {email: this.email, password: this.password})
        },
        onDismissed() {
            this.$store.dispatch('clearError')
        }
    }
}
</script>

<style lang="scss" scoped>
    .custom-loader {
        animation: loader 1s infinite;
        display: flex;
    }

    @keyframes loader {
        from {
        transform: rotate(0);
        }
        to {
        transform: rotate(360deg);
        }
    }
</style>
